import { render } from "./BaseLoading.vue?vue&type=template&id=7542b10e"
import script from "./BaseLoading.vue?vue&type=script&lang=js"
export * from "./BaseLoading.vue?vue&type=script&lang=js"

import "./BaseLoading.vue?vue&type=style&index=0&id=7542b10e&lang=css"
script.render = render

export default script